<app-sub-navbar [routes]="routes"></app-sub-navbar>
<router-outlet></router-outlet>
